import { store, store$ } from '@redux/store';
import { getBrandName, routingStateActions } from 'features/routing';
import { map, distinctUntilChanged, filter, skip } from 'rxjs';
import { selectBrand, ResultType } from 'features/searchResultsFacets';

const onBuilderSelected$ = store$.pipe(map(selectBrand), filter(Boolean), distinctUntilChanged(), skip(1));

/**
 * updateUrlPaging: Updates the page on the url.
 * @param {Number} pageNumber Number of the selected page.
 */
const updateBuilderName = (brand) => {
  setTimeout(() => {
    const { brandName, brandId, resultType } = brand;
    const builderSegment = resultType !== ResultType.Builders.toString() ? getBrandName(brandName, brandId) : '';

    store.dispatch(routingStateActions.updateBuilderName(builderSegment));
  });
};

onBuilderSelected$.subscribe(updateBuilderName);
